import React, { useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import CommonTagsInput from "../../core/common/Taginput";
import { DatePicker } from "antd";
import JoditEditor from "jodit-react";
import dayjs, { Dayjs } from "dayjs";
import useApi from "../../core/customhook/useApi";
import Select from "react-select";
import Swal from "sweetalert2";
import { apibaseurl, base_path } from "../../environment";

const ProjectList = () => {
  const [tags, setTags] = useState<string[]>([]);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [callApiAgain, setCallApiAgain] = useState(1);

  const {
    data: costcenter,
    loading: costcenterLoading,
    error: costcenterError,
  } = useApi("/api/master/get-costcenter", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: department,
    loading: departmentLoading,
    error: departmentError,
  } = useApi("/api/manager/view-department", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: projectResponse,
    loading: projectDataLoading,
    error: projectDataError,
  } = useApi("/api/get-project", {
    method: "GET",
    autoCall: true,
    dependencies: [callApiAgain],
  });

  const projectData = projectResponse?.projects
    ?.reverse()
    .map((item: any, index: any) => {
      return {
        ...item,
        sno: index + 1,
      };
    });

  const departmentData = department?.data;

  const filterData = departmentData?.filter((item: any, index: any) => {
    return item.status === "1";
  });

  const costCenterOptions =
    costcenter?.data.map((item: any) => ({
      value: item.costcentre_code,
      label: `${item.costcentre_code} - ${item.costcentre_name}`,
    })) || [];

  const DepartmentSelectData =
    filterData?.map((item: any) => ({
      value: item.ID,
      label: `${item.department}`,
    })) || [];

  const config = useMemo(
    () => ({
      readonly: false,
    }),
    []
  );
  const columns = [
    {
      title: "S No",
      dataIndex: "sno",
      sorter: (a: any, b: any) => a.sno.length - b.sno.length,
    },
    {
      title: "Project Name",
      dataIndex: "project_name",
      sorter: (a: any, b: any) => a.project_name.length - b.project_name.length,
    },
    {
      title: "Owner",
      dataIndex: "owner_name",
      sorter: (a: any, b: any) => a.owner_name.length - b.owner_name.length,
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      render: (text: string) => (
        <span>{text ? dayjs(text).format("D MMMM YYYY") : "N/A"}</span>
      ),
      sorter: (a: any, b: any) =>
        new Date(a.start_date).getTime() - new Date(b.start_date).getTime(),
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      render: (text: string) => (
        <span>{text ? dayjs(text).format("D MMMM YYYY") : "N/A"}</span>
      ),
      sorter: (a: any, b: any) =>
        new Date(a.end_date).getTime() - new Date(b.end_date).getTime(),
    },
    {
      title: "Attachment",
      dataIndex: "attachment_file",
      render: (text: string) =>
        text ? (
          <a
            href={`${apibaseurl}${text}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1890ff", textDecoration: "underline" }}
          >
            View
          </a>
        ) : (
          <span>N/A</span>
        ),
    },
    {
      title: "Priority",
      dataIndex: "priority",
      render: (text: string) => (
        <div className="d-flex align-items-center">
          <span
            className={`rounded-circle d-flex justify-content-center align-items-center me-2 ${text === "High"
              ? "bg-transparent-danger"
              : text === "Low"
                ? "bg-transparent-success"
                : "bg-transparent-warning"
              }`}
            style={{ width: 10, height: 10 }}
          >
            <i
              className={`ti ti-point-filled ${text === "High"
                ? "text-danger"
                : text === "Low"
                  ? "text-success"
                  : "text-warning"
                }`}
            />
          </span>
          <span>{text}</span>
        </div>
      ),
      sorter: (a: any, b: any) => a.Priority.length - b.Priority.length,
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (text: string, record: any) => (
        <span
          className={`badge  ${text === "Active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text === "Active" ? "Active" : "Inactive"}
        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to={`/projects/edit-project/${record.project_id}`}
            className="me-2"
          // data-bs-toggle="modal"
          // data-inert={true}
          // data-bs-target="#edit_project"
          // onClick={() => {
          //   setData({
          //     project_id: record.project_id,
          //     project_name: record.project_name,
          //     owner_name: record.owner_name,
          //     priority: record.priority,
          //     cost_center: record.cost_center_code,
          //     department: record.department,
          //     status: record.status,
          //     attachment_file: "",
          //   });

          //   setStartDate(dayjs(record.start_date));
          //   setEndDate(dayjs(record.end_date));
          //   setTags(record.tags?.map((tag: any) => tag.tag_name) || []);
          //   setContent(record.description);
          // }}
          >
            <i className="ti ti-edit" />
          </Link>
          {/* <Link to="#" onClick={() => deleteProject(record.project_id)}>
            <i className="ti ti-trash" />
          </Link> */}
        </div>
      ),
    },
  ];

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };
  const [data, setData] = useState({
    project_id: "",
    project_name: "",
    owner_name: "",
    priority: "",
    cost_center: "",
    department: "",
    attachment_file: "",
    status: ""
  });

  const getInputData = (
    e: React.ChangeEvent<any>
  ) => {
    const { name, value, files } = e.target;
    if (name === "attachment_file") {
      setData({ ...data, [name]: files[0] });
    }
    else {
      setData({ ...data, [name]: value });
    }
  };

  const {
    data: addprojectResponse,
    loading: addprojectDataLoading,
    error: addprojectDataError,
    callApi: addProject,
  } = useApi("/api/add-project", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append("project_name", data.project_name);
    formData.append("owner_name", data.owner_name);
    formData.append("description", content);
    tags.forEach((tag) => {
      formData.append("tag_name[]", tag);
    });
    formData.append(
      "start_date",
      startDate ? startDate.format("YYYY-MM-DD") : ""
    );
    formData.append("end_date", endDate ? endDate.format("YYYY-MM-DD") : "");
    formData.append("priority", data.priority);
    formData.append("cost_center_code", data.cost_center);
    formData.append("department", data.department);
    formData.append("attachment_file", data.attachment_file);

    try {
      const response = await addProject(formData);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Project Added",
          text:
            response?.message || "Your project has been added successfully.",
          confirmButtonColor: "#3085d6",
        });
        document.getElementById("closed_modal")?.click();
        setCallApiAgain(callApiAgain + 1);
        setData({
          project_id: "",
          project_name: "",
          owner_name: "",
          priority: "",
          cost_center: "",
          department: "",
          attachment_file: "",
          status: ""
        });
        setTags([]);
        setStartDate(null);
        setEndDate(null);
        setContent("");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const {
    data: editprojectResponse,
    loading: editprojectDataLoading,
    error: editprojectDataError,
    callApi: editProject,
  } = useApi("/api/edit-project", {
    method: "POST",
    autoCall: false,
  });

  const editData = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("project_id", data.project_id);
    formData.append("project_name", data.project_name);
    formData.append("owner_name", data.owner_name);
    formData.append("description", content);
    tags.forEach((tag) => {
      formData.append("tag_name[]", tag);
    });
    formData.append(
      "start_date",
      startDate ? startDate.format("YYYY-MM-DD") : ""
    );
    formData.append("end_date", endDate ? endDate.format("YYYY-MM-DD") : "");
    formData.append("priority", data.priority);
    formData.append("cost_center_code", data.cost_center);
    formData.append("department", data.department);
    formData.append("status", data.status);
    formData.append("attachment_file", data.attachment_file);
    try {
      const response = await editProject(formData);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Project Update",
          text:
            response?.message || "Your project has been updated successfully.",
          confirmButtonColor: "#3085d6",
        });
        document.getElementById("closed_edit_modal")?.click();
        setCallApiAgain(callApiAgain + 1);
        setData({
          project_id: "",
          project_name: "",
          owner_name: "",
          priority: "",
          cost_center: "",
          department: "",
          attachment_file: "",
          status: ""
        });
        setTags([]);
        setStartDate(null);
        setEndDate(null);
        setContent("");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const {
    data: deleteprojectResponse,
    loading: deleteprojectDataLoading,
    error: deleteprojectDataError,
    callApi: projectDelete,
  } = useApi("", {
    method: "DELETE",
    autoCall: false,
  });

  const deleteProject = async (ID: any) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this Project",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (confirmResult.isConfirmed) {
      try {
        const response = await projectDelete(
          undefined,
          "/api/delete-project/" + ID
        );
        if (response.success) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: response?.message || "Project has been deleted successfully.",
            showConfirmButton: true,
          });
          setCallApiAgain(callApiAgain + 1);
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: "Could not delete the Project.",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while deleting the Project.",
        });
      }
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Projects</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Projects
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <Link
                  to="/projects/add-project"
                  // to={"#"}
                  // data-bs-toggle="modal"
                  // data-inert={true}
                  // data-bs-target="#add_project"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Project
                </Link>
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Project list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Project List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Select Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div> */}
                {/* <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Desending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                dataSource={projectData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
          {/* / Project list  */}
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Add Project */}
      <div className="modal fade" id="add_project" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header header-border align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h5 className="modal-title me-2">Add Project </h5>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closed_modal"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="add-info-fieldset ">
              <div className="contact-grids-tab p-3 pb-0">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="basic-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Project Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="basic-tab"
                  tabIndex={0}
                >
                  <form onSubmit={postData}>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Project Name<sup className="text-danger">*</sup>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Project Name"
                              name="project_name"
                              onChange={getInputData}
                              value={data.project_name}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Owner<sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Owner Name"
                                    name="owner_name"
                                    onChange={getInputData}
                                    value={data.owner_name}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6 mb-3">
                              <label
                                htmlFor="costcenter_code"
                                className="form-label"
                              >
                                <strong>Cost Center</strong>
                                <sup className="text-danger">*</sup>
                              </label>
                              <Select
                                id="cost_center"
                                name="cost_center"
                                options={costCenterOptions}
                                onChange={(selectedOption: any) => {
                                  getInputData({
                                    target: {
                                      name: "cost_center",
                                      value: selectedOption?.value || "",
                                    },
                                  } as any);
                                }}
                                placeholder="Select Cost Center"
                                styles={{
                                  menu: (provided: any) => ({
                                    ...provided,
                                    maxHeight: 250,
                                    overflowY: "auto",
                                    scrollbarWidth: "none",
                                  }),
                                }}
                              />
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Department<sup className="text-danger">*</sup>
                                </label>
                                <Select
                                  id="department"
                                  name="department"
                                  options={DepartmentSelectData}
                                  onChange={(selectedOption: any) => {
                                    getInputData({
                                      target: {
                                        name: "department",
                                        value: selectedOption?.value || "",
                                      },
                                    } as any);
                                  }}
                                  placeholder="Select Department"
                                  styles={{
                                    menu: (provided: any) => ({
                                      ...provided,
                                      maxHeight: 250,
                                      overflowY: "auto",
                                      scrollbarWidth: "none",
                                    }),
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Start Date<sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <DatePicker
                                    className="form-control datetimepicker"
                                    format={{
                                      format: "DD-MM-YYYY",
                                      type: "mask",
                                    }}
                                    value={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    getPopupContainer={getModalContainer}
                                    placeholder="DD-MM-YYYY"
                                    disabledDate={(current) => {
                                      return current &&
                                        current.isBefore(dayjs().startOf("day"))
                                        ? true
                                        : false;
                                    }}
                                  />

                                  <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-7" />
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  End Date<sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <DatePicker
                                    className="form-control datetimepicker"
                                    format={{
                                      format: "DD-MM-YYYY",
                                      type: "mask",
                                    }}
                                    value={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    getPopupContainer={getModalContainer}
                                    placeholder="DD-MM-YYYY"
                                    disabledDate={(current) => {
                                      // Disable dates before today's date or before the start date
                                      return current &&
                                        (current.isBefore(
                                          dayjs().startOf("day")
                                        ) ||
                                          (startDate &&
                                            current.isBefore(startDate)))
                                        ? true
                                        : false;
                                    }}
                                  />

                                  <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-7" />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label me-2">
                              Tags<sup className="text-danger">*</sup>
                            </label>
                            <CommonTagsInput
                              value={tags}
                              onChange={setTags}
                              placeholder="Add new"
                              className="custom-input-class"
                            />
                            <label className="form-label me-2">
                              <sub className="text-danger">
                                (Press enter to add more)
                              </sub>
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Priority<sup className="text-danger">*</sup>
                            </label>
                            <select
                              className="form-select"
                              name="priority"
                              onChange={getInputData}
                              value={data.priority}
                            >
                              <option>Select Priority</option>
                              <option value="High">High</option>
                              <option value="Medium">Medium</option>
                              <option value="Medium">Medium</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block mb-0">
                            <label className="form-label">Upload File</label>
                            <input
                              className="form-control"
                              type="file"
                              name="attachment_file"
                              onChange={getInputData}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Description<sup className="text-danger">*</sup>
                            </label>
                            <JoditEditor
                              ref={editor}
                              value={content}
                              config={config}
                              tabIndex={1}
                              onBlur={(newContent) => setContent(newContent)}
                              onChange={(newContent) => { }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button className="btn btn-primary" type="submit">
                          Add Project
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Project */}

      {/* Edit Project */}
      <div className="modal fade" id="edit_project" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header header-border align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h5 className="modal-title me-2">Edit Project </h5>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closed_edit_modal"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="add-info-fieldset ">
              <div className="contact-grids-tab p-3 pb-0">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="basic-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Project Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="basic-tab"
                  tabIndex={0}
                >
                  <form onSubmit={editData}>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Project Name<sup className="text-danger">*</sup>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Project Name"
                              name="project_name"
                              onChange={getInputData}
                              value={data.project_name}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Owner<sup className="text-danger">*</sup>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Owner Name"
                                  name="owner_name"
                                  onChange={getInputData}
                                  value={data.owner_name}
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Cost Center Code
                                  <sup className="text-danger">*</sup>
                                </label>
                                <Select
                                  name="cost_center"
                                  options={costCenterOptions}
                                  value={costCenterOptions.find(
                                    (option: any) =>
                                      option.value === data.cost_center
                                  )}
                                  onChange={(selected: any) =>
                                    setData((prev) => ({
                                      ...prev,
                                      cost_center: selected?.value || "",
                                    }))
                                  }
                                  placeholder="Select Cost Center"
                                  styles={{
                                    menu: (provided: any) => ({
                                      ...provided,
                                      maxHeight: 250,
                                      overflowY: "auto",
                                      scrollbarWidth: "none",
                                    }),
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Department<sup className="text-danger">*</sup>
                                </label>
                                <Select
                                  id="department"
                                  name="department"
                                  options={DepartmentSelectData}
                                  value={DepartmentSelectData.find(
                                    (option: any) =>
                                      option.value == data.department
                                  )}
                                  onChange={(selectedOption: any) => {
                                    getInputData({
                                      target: {
                                        name: "department",
                                        value: selectedOption?.value || "",
                                      },
                                    } as any);
                                  }}
                                  placeholder="Select Department"
                                  styles={{
                                    menu: (provided: any) => ({
                                      ...provided,
                                      maxHeight: 250,
                                      overflowY: "auto",
                                      scrollbarWidth: "none",
                                    }),
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Start Date<sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <DatePicker
                                    className="form-control datetimepicker"
                                    value={startDate}
                                    format={{
                                      format: "DD-MM-YYYY",
                                      type: "mask",
                                    }}
                                    onChange={(date) => setStartDate(date)}
                                    getPopupContainer={getModalContainer}
                                    placeholder="DD-MM-YYYY"
                                    disabledDate={(current) =>
                                      current &&
                                      current.isBefore(dayjs().startOf("day"))
                                    }
                                  />
                                  <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-7" />
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  End Date<sup className="text-danger">*</sup>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <DatePicker
                                    className="form-control datetimepicker"
                                    value={endDate}
                                    format={{
                                      format: "DD-MM-YYYY",
                                      type: "mask",
                                    }}
                                    onChange={(date) => setEndDate(date)}
                                    getPopupContainer={getModalContainer}
                                    placeholder="DD-MM-YYYY"
                                    disabledDate={(current: any) =>
                                      current &&
                                      (current.isBefore(
                                        dayjs().startOf("day")
                                      ) ||
                                        (startDate &&
                                          current.isBefore(startDate)))
                                    }
                                  />
                                  <span className="input-icon-addon">
                                    <i className="ti ti-calendar text-gray-7" />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label me-2">
                              Tags<sup className="text-danger">*</sup>
                            </label>
                            <CommonTagsInput
                              value={tags}
                              onChange={setTags}
                              placeholder="Add new"
                              className="custom-input-class"
                            />
                            <label className="form-label me-2">
                              <sub className="text-danger">
                                (Press enter to add more)
                              </sub>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Priority<sup className="text-danger">*</sup>
                            </label>
                            <select
                              className="form-select"
                              name="priority"
                              onChange={getInputData}
                              value={data.priority}
                            >
                              <option value="">Select Priority</option>
                              <option value="High">High</option>
                              <option value="Medium">Medium</option>
                              <option value="Low">Low</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="input-block mb-0">
                            <label className="form-label">Upload File</label>
                            <input
                              className="form-control"
                              type="file"
                              name="attachment_file"
                              onChange={getInputData}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Description<sup className="text-danger">*</sup>
                            </label>
                            <JoditEditor
                              ref={editor}
                              value={content}
                              config={config}
                              tabIndex={1}
                              onBlur={(newContent) => setContent(newContent)}
                              onChange={() => { }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block mb-0">
                            <label className="form-label">Status</label>
                            <select name="status" id="" onChange={getInputData} value={data.status} className="form-select">
                              <option value="Active">Active</option>
                              <option value="Inactive">Inactive</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button className="btn btn-primary" type="submit">
                          Edit Project
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Project */}
      {/* Add Project Success */}
      <div className="modal fade" id="success_modal" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center p-3">
                <span className="avatar avatar-lg avatar-rounded bg-success mb-3">
                  <i className="ti ti-check fs-24" />
                </span>
                <h5 className="mb-2">Project Added Successfully</h5>
                <p className="mb-3">
                  Stephan Peralt has been added with Client ID :{" "}
                  <span className="text-primary">#pro - 0004</span>
                </p>
                <div>
                  <div className="row g-2">
                    <div className="col-6">
                      <Link
                        to={all_routes.project}
                        className="btn btn-dark w-100"
                      >
                        Back to List
                      </Link>
                    </div>
                    <div className="col-6">
                      <Link
                        to={all_routes.projectdetails}
                        className="btn btn-primary w-100"
                      >
                        Detail Page
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Project Success */}
    </>
  );
};

export default ProjectList;
